import React from 'react';
import PropTypes from 'prop-types';

import './AriaErrors.css';

function AriaErrors({ isCritical, messages }) {
  const announcement = isCritical
    ? messages
        .filter(Boolean)
        .map((m) => m.replace(/\.+$/, '')) // Remove trailing period to avoid ..
        .join('. ')
    : '';

  // The aria-live region should always be rendered for a11y reasons.
  return (
    <div aria-live='polite' aria-atomic='true' className='AriaErrors'>
      {announcement}
    </div>
  );
}

AriaErrors.propTypes = {
  isCritical: PropTypes.bool.isRequired,
  messages: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  ).isRequired,
};

export default AriaErrors;
